<template>
    <div class="lms__superadmin_users_bulk_actions_resend_invitations_select_users">
        <component-list
            ref="componentlist"
            :component-table="LmsSuperadminUsersBulkActionsResendInvitationsSelectUsersTable"
            :component-table-name="'users'"
            :filter-search-queryable="true"
            :filter-select-active="Boolean(filtersSelect.length)"
            :filter-select-items="filtersSelect"
            :get-pagination-getter="'getLmsSuperadminWorkspaceUsersPagination'"
            :get-items-getter="'getLmsSuperadminWorkspaceUsers'"
            :get-items-dispatch="'lmsSuperadminWorkspaceUsersGet'"
            :get-items-dispatch-trigger-name="'trigger-get-users'"
            :get-items-dispatch-params="{ workspaceId: loggedInUserWorkspaceId }"
            :force-loading-trigger-name="'trigger-loading-users'"
            :filter-select-prefix="''"
            :item-name="['user', 'users']"
            :default-page-size="12"
            :table-preferences-active="true"
            :selected="selectedUsersProfileIds"
            @emit-check="handleCheck"
        ></component-list>
    </div>
</template>

<script>
import ComponentList from '@/components/default/shared/ComponentList'
import LmsSuperadminUsersBulkActionsResendInvitationsSelectUsersTable from '@/components/lms/superadmin/users/bulk/actions/resendinvitations/LmsSuperadminUsersBulkActionsResendInvitationsSelectUsersTable'

export default {
  name: 'lms-superadmin-users-bulk-actions-resend-invitations-select-users',
  components: { ComponentList },
  data () {
    return {
      LmsSuperadminUsersBulkActionsResendInvitationsSelectUsersTable
    }
  },
  computed: {
    bulkActionPending () {
      return this.$store.getters.getLmsSuperadminUsersBulkActionsResendInvitationsActionPending
    },
    bulkActionCompleted () {
      return this.$store.getters.getLmsSuperadminUsersBulkActionsResendInvitationsActionCompleted
    },
    selectedUsersProfileIds () {
      return this.$store.getters.getLmsSuperadminUsersBulkActionsResendInvitationsItemsProfileIds
    },
    loggedInUserWorkspaceId () {
      return this.$store.getters.getAuthUserSecondStageTokenDataWorkspaceId
    },
    filtersSelect () {
      let tableArr = []

      tableArr.push({
        key: 'roles',
        label: 'Roles',
        type: 'multiselect',
        getItemsGetter: 'getLmsSuperadminCustomerRolesMappedIdName',
        getItemsGetterMapped: 'getLmsSuperadminCustomerRoles',
        getItemsDispatch: 'lmsSuperadminCustomerRolesGet',
        itemName: ['role', 'roles'],
        tableLabels: [
          {
            key: 'name',
            title: 'Name',
            type: 'string',
            sortable: true,
            queryable: true
          }
        ]
      })
      tableArr.push({
        key: 'units',
        label: 'Organisation unit',
        type: 'org-units',
        preselected: this.routeOrgUnitsQueryMapped
      })
      tableArr.push({
        key: 'groups',
        label: 'Groups',
        type: 'multiselect',
        getItemsGetter: 'getLmsSuperadminGroupsMappedIdName',
        getItemsGetterMapped: 'getLmsSuperadminGroupsMappedLabelValue',
        getItemsDispatch: 'lmsSuperadminGroupsGet',
        itemName: ['group', 'groups'],
        searchQueryable: true,
        preselected: this.routeGroupsQueryMapped,
        tableLabels: [
          {
            key: 'name',
            title: 'Name',
            type: 'string',
            sortable: true,
            queryable: true
          }
        ]
      })
      tableArr.push({
        key: 'status',
        label: 'Status',
        type: 'checkbox',
        disabled: true,
        preselected: ['invited', 'cancelled', 'rejected'],
        preventClear: true,
        values: [
          {
            label: 'Invited',
            value: 'invited'
          },
          {
            label: 'Cancelled',
            value: 'cancelled'
          },
          {
            label: 'Rejected',
            value: 'rejected'
          }
        ]
      })

      return tableArr
    }
  },
  methods: {
    handleCheck (data) {
      this.$store.dispatch('lmsSuperadminUsersBulkActionsResendInvitationsSetItems', data)
    },
    redirectToBulkActionsResendInvitationsSummary () {
      this.$router.push({ name: 'lms-superadmin-user-bulk-actions-resend-invitations-summary' })
    }
  },
  mounted () {
    if (this.bulkActionPending || this.bulkActionCompleted) {
      this.redirectToBulkActionsResendInvitationsSummary()
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/superadmin/users/_lmssuperadminusersbulkactionsresendinvitationsselectusers.scss";
</style>
